<template>


<main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                
                <div class="row mb-32 gy-0 dash-top" style="padding-bottom: 500px; ">

                    <!-- POSTS -->
                    <div class="col-12" style="z-index: 9;">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" >
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="pending-tab" data-bs-toggle="tab"
                                            data-bs-target="#pending" role="tab" aria-controls="pending"
                                            aria-selected="true" style="cursor: pointer;"> Pending</h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="completed-tab" data-bs-toggle="tab"
                                            data-bs-target="#completed" role="tab" aria-controls="completed"
                                            aria-selected="false" style="cursor: pointer;"> Completed <strong
                                                style="margin-left: 5px;"></strong></h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="cancelled-tab" data-bs-toggle="tab"
                                            data-bs-target="#cancelled" role="tab" aria-controls="cancelled"
                                            aria-selected="false" style="cursor: pointer;"> Cancelled <strong
                                                style="margin-left: 5px;"></strong></h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content">

                                    <!-- Pending -->
                                    <div class="tab-pane fade show active" id="pending" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        <div class="mt-18 mb-24">

                                            <input type="text" class="form-control" id="exampleInputEmail1"
                                                aria-describedby="emailHelp" style="background-color: transparent;"
                                                placeholder="Search pending transactions...">

                                        </div>

                                        

                                        <!-- DUPLI -->
                                        <div class="row">
                                            <div class="col-12 col-xl-4" v-for="pending in pendingList" :key="pending.id" style="margin-bottom: 10px;">
                                            <div class="card hp-card-6">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-12 text-center">
                                                            <div class="mt-16" style="padding-left: 10px; padding-right: 10px; ">

                                                                <div class="mb-32">
                                                                    <img :src="pending.profilePic" alt="" style="object-fit: cover; width: 70px; height: 70px; ">

                                                                    <h6 style="text-align: center; margin-top: 10px;">{{ pending.fullName }}</h6>
                                                                    <p style="text-align: center; margin-top: -15px;">@{{ pending.userName }}</p>
                                                                </div>

                                                                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>
                                                                

                                                                <div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Bank name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ pending.bankName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account number</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700; width: 100%; word-break: break-all; " class="hp-p1-body text-black-100" >{{ pending.accountNumber }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700; width: 100%; word-break: break-all; " class="hp-p1-body text-black-100" >{{ pending.accountName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Payout amount</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >&#8358;{{ pending.payoutAmountD }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Status</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-warning" >Pending</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Date</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ pending.dateFull }}</p>

                                                                    </div>

                                                                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-8 px-0"></div>

                                                                </div>

                                                                <div style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 50px; margin-bottom: 30px;">
                                                                    <button class="btn btn-primary " @click="approve(pending)">Approve</button>
                                                                    <button class="btn btn-danger  " style="margin-left: 40px;" @click="decline(pending)">Decline</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyPending2">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; display: none;"
                                            id="emptyPending" >
                                            <p class="hp-badge-text">No pending payouts...</p>
                                        </div>
                                        

                                    </div>

                                    <!-- COMPLETED -->
                                    <div class="tab-pane fade show" id="completed" role="tabpanel"
                                        aria-labelledby="completed-tab">

                                        <div class="mt-18 mb-24">

                                            <input type="text" class="form-control"
                                                aria-describedby="emailHelp" style="background-color: transparent;"
                                                placeholder="Search completed payouts...">

                                        </div>

                                        <!-- DUPLI -->
                                        <div class="row">
                                            <div class="col-12 col-xl-4" v-for="completed in completedList" :key="completed.id" style="margin-bottom: 10px;">
                                            <div class="card hp-card-6">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-12 text-center">
                                                            <div class="mt-16" style="padding-left: 10px; padding-right: 10px;">

                                                                <div class="mb-32">
                                                                    <img :src="completed.profilePic" alt="" style="object-fit: cover; width: 70px; height: 70px; ">

                                                                    <h6 style="text-align: center; margin-top: 10px;">{{ completed.fullName }}</h6>
                                                                    <p style="text-align: center; margin-top: -15px;">@{{ completed.userName }}</p>
                                                                </div>

                                                                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>
                                                                

                                                                <div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Bank name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ completed.bankName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account number</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ completed.accountNumber }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ completed.accountName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Payout amount</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >&#8358;{{ completed.payoutAmountD }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Status</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-success" >Completed</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Date</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ completed.dateFull }}</p>

                                                                    </div>

                                                                    
                                                                    

                                                                </div>

                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyCompleted2">

                                            <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; display: none;"
                                            id="emptyCompleted" >
                                            <p class="hp-badge-text">No completed payouts...</p>
                                        </div>
                                        

                                    </div>

                                    <!-- CANCELLED -->
                                    <div class="tab-pane fade show" id="cancelled" role="tabpanel"
                                        aria-labelledby="cancelled-tab">

                                        <div class="mt-18 mb-24">

                                            <input type="text" class="form-control"
                                                aria-describedby="emailHelp" style="background-color: transparent;"
                                                placeholder="Search completed payouts...">

                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-12 col-xl-4" v-for="cancelled in cancelledList" :key="cancelled.id" style="margin-bottom: 10px;">
                                            <div class="card hp-card-6">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-12 text-center">
                                                            <div class="mt-16" style="padding-left: 10px; padding-right: 10px;">

                                                                <div class="mb-32">
                                                                    <img :src="cancelled.profilePic" alt="" style="object-fit: cover; width: 70px; height: 70px; ">

                                                                    <h6 style="text-align: center; margin-top: 10px;">{{ cancelled.fullName }}</h6>
                                                                    <p style="text-align: center; margin-top: -15px;">@{{ cancelled.userName }}</p>
                                                                </div>

                                                                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>
                                                                

                                                                <div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Bank name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ cancelled.bankName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account number</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ cancelled.accountNumber }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Account name</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ cancelled.accountName }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Payout amount</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >&#8358;{{ cancelled.payoutAmountD }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Status</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-danger" >Cancelled</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Date</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ cancelled.dateFull }}</p>

                                                                    </div>

                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyCancelled2">

                                            <InfiniteLoading @infinite="handleInfinite3" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; display: none;"
                                            id="emptyCancelled" >
                                            <p class="hp-badge-text">No cancelled payouts...</p>
                                        </div>
                                        

                                    </div>
                                    

                                </div>

                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

</main>


<!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- APPROVE -->
        <div class="modal fade" id="approveModal" tabindex="-1" aria-labelledby="approveLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Are you sure?</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body"> Please ensure that you have completed this transaction before approving </p>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        @click="approve2">Confirm</button>
                </div>
            </div>
        </div>
        </div>

        <!-- DECLINE -->
        <div class="modal fade" id="declineModal" tabindex="-1" aria-labelledby="declineModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title">Decline Payout ?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <p class="hp-p1-body">Are you sure you want to decline this transaction</p>

                    <form @submit.prevent="decline2">

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Reason</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Reason for declining the transaction..." style="line-height: 20px; padding-top: 10px;"
                                v-model="reason" maxlength="500" required></textarea>
                        </div>

                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal" aria-label="Close">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>







                </div>


            </div>
        </div>
    </div>


</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
    import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, } from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText: "",
                errorText: "",
                successText: "",

                lastDocSnapshot: null,
                lastDocSnapshot2: null,
                lastDocSnapshot3: null,
                
                pendingList: [],
                completedList: [],
                cancelledList: [],

                payoutObj: "",
                reason: "",
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display = 'none';
            document.getElementById("mobileTitle").textContent = 'Payouts';

            document.getElementById("payoutsN").classList.add("active");

            document.getElementById("payoutsN2").classList.add("active");

        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getPending(){

                let res = [];
                const q = query(collection(db, "UserTrans"), where("type", "==", "Withdraw2"), where("status", "==", "pending"), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            status: doc.data().status,
                            accountName: doc.data().accountName,
                            accountNumber: doc.data().accountNumber,
                            bankName: doc.data().bankName,
                            commission: doc.data().commission,
                            serviceCharge: doc.data().serviceCharge,
                            payoutAmount: doc.data().payoutAmount,
                            payoutAmountD: Number(doc.data().payoutAmount).toLocaleString("US-us"),

                            dateFull: a2.slice(0, -36),
                            
                        }

                        this.pendingList.push(result);

                    })

                }

                return res.length;

            },

            async getCompleted(){

                let res = [];
                const q = query(collection(db, "UserTrans"), where("type", "==", "Withdraw2"), where("status", "==", "completed"), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot2 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            status: doc.data().status,
                            accountName: doc.data().accountName,
                            accountNumber: doc.data().accountNumber,
                            bankName: doc.data().bankName,
                            commission: doc.data().commission,
                            serviceCharge: doc.data().serviceCharge,
                            payoutAmount: doc.data().payoutAmount,
                            payoutAmountD: Number(doc.data().payoutAmount).toLocaleString("US-us"),

                            dateFull: a2.slice(0, -36),
                            
                        }

                        this.completedList.push(result);

                    })

                    
                }

                return res.length;

            },

            async getCancelled(){

                let res = [];
                const q = query(collection(db, "UserTrans"), where("type", "==", "Withdraw2"), where("status", "==", "cancelled"), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot3 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot3 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            status: doc.data().status,
                            accountName: doc.data().accountName,
                            accountNumber: doc.data().accountNumber,
                            bankName: doc.data().bankName,
                            commission: doc.data().commission,
                            serviceCharge: doc.data().serviceCharge,
                            payoutAmount: doc.data().payoutAmount,
                            payoutAmountD: Number(doc.data().payoutAmount).toLocaleString("US-us"),

                            dateFull: a2.slice(0, -36),
                            
                        }

                        this.cancelledList.push(result);

                    })

                    
                }

                return res.length;

            },

            async handleInfinite($state){

                const newPostCount = await this.getPending();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.pendingList.length == 0){
                        document.getElementById("emptyPending").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyPending2").style.display = "none";
                    return $state.complete();

            },

            async handleInfinite2($state){

                const newPostCount = await this.getCompleted();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.completedList.length == 0){
                        document.getElementById("emptyCompleted").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyCompleted2").style.display = "none";
                    return $state.complete();

            },

            async handleInfinite3($state){

                const newPostCount = await this.getCancelled();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.completedList.length == 0){
                        document.getElementById("emptyCancelled").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyCancelled2").style.display = "none";
                    return $state.complete();

            },

            approve(obj){
                this.payoutObj = obj;
                $('#approveModal').modal('show');
            },

            async approve2(){

                //loading
                this.loadingText = "Approving transaction...";
                this.$refs.loadingModal.classList.add("bg-active");

                //send mail to user
                axios.post('https://api.baesnap.com/v1/withdraw-success-mail', {
                    toName: this.payoutObj.fullName,
                    toEmail: this.payoutObj.email,
                    payoutAmount: this.payoutObj.payoutAmountD 
                })
                .then(function (response) {
                    console.log(response);
                })
                
                //update trans
                const transRef = doc(db, "UserTrans", this.payoutObj.id);
                await updateDoc(transRef, {
                    status: "completed"
                });

                this.successText = "Transaction was approved successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            decline(obj){

                this.payoutObj = obj;
                $('#declineModal').modal('show');

            },

            async decline2(){

                //loading
                this.loadingText = "Declining transaction...";
                this.$refs.loadingModal.classList.add("bg-active");

                //send mail to user
                axios.post('https://api.baesnap.com/v1/withdraw-failed-mail', {
                    toName: this.payoutObj.fullName,
                    toEmail: this.payoutObj.email,
                    payoutAmount: this.payoutObj.payoutAmountD,
                    reason: this.reason
                })
                .then(function (response) {
                    console.log(response);
                })
                
                //update trans
                const transRef = doc(db, "UserTrans", this.payoutObj.id);
                await updateDoc(transRef, {
                    status: "cancelled"
                });

                //refund user
                let refund = Number(this.payoutObj.commission) + Number(this.payoutObj.serviceCharge) + Number(this.payoutObj.payoutAmount);
                const userRef = doc(db, "Users", this.payoutObj.userId);
                await updateDoc(userRef, {
                    earnings: increment(refund) 
                });

                this.successText = "Transaction was declined successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

        }

        
    }
</script>